'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaticResource(_ref) {
  var resource = _ref.resource;

  var mimeType = resource.getAttr('creativeType');
  var renderable = null;

  if (mimeType.indexOf('image') === 0) {
    renderable = _react2.default.createElement('img', { role: 'presentation', src: resource.getValue() });
  } else if (mimeType.indexOf('text/css') === 0) {
    renderable = _react2.default.createElement('link', {
      rel: 'stylesheet',
      property: 'stylesheet',
      href: resource.getValue()
    });
  } else if (mimeType.indexOf('application/javascript') === 0) {
    renderable = _react2.default.createElement('script', {
      src: resource.getValue()
    });
  } else {
    console.warn('Static Resource Of MIME Type ' + mimeType + ' Not Supported!');
  }

  return renderable;
}

StaticResource.propTypes = {
  resource: _react2.default.PropTypes.object.isRequired
};

exports.default = StaticResource;
//# sourceMappingURL=static-resource.js.map


// WEBPACK FOOTER //
// ./src/resources/static-resource.js